import axios from "axios";
import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { baseURL } from "../../config";

function MyTeamCompetency({ managerId }) {
  const [teamMembers, setTeamMembers] = useState([]);
  const id = localStorage.getItem("employeeid");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
        console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    //   alert(managerId);
    // if (managerId) {
    fetchData();
    //}
  }, [managerId]);

  return (
    <div className="row m-3">
      <h4>My Team Competencies</h4>
      <p>You can set the Competencies for each of your team members.</p>
      {teamMembers.map((member, index) => (
        <Card
          key={index}
          className="m-2 Regular shadow p-1"
          style={{ width: "12rem" }}
        >
          <Card.Img
            className="w-50 m-auto pt-3"
            variant="top center"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
          />
          <Card.Body className="p-1">
            <Card.Title className="text-center">
              <h5>
                {member.FirstName} {member.LastName}
              </h5>
            </Card.Title>
            <Card.Text className="text-center">
              <p className="card_des">{member.employeeid}</p>
              <p className="skill_card_status">
                {" "}
                Status : <span>{member.status}</span>
              </p>
              <p className="card_des">
                <a
                  href={`/appraisalteammember?id=${member.employeeid}`}
                  className="text-black"
                >
                  View Appraisal
                </a>
              </p>
            </Card.Text>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
}

export default MyTeamCompetency;
